import _classCallCheck from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { deepMix } from '@antv/util';
export var Base = /*#__PURE__*/function () {
  /**
   * 构造函数，根据自定义的选项和默认选项生成当前选项
   * @param options 需要自定义配置的选项
   */
  function Base(options) {
    _classCallCheck(this, Base);

    this.options = deepMix({}, this.getDefaultOptions());
    this.update(options);
  }
  /**
   * 返回当前的所有选项
   * @returns 当前的所有选项
   */


  _createClass(Base, [{
    key: "getOptions",
    value: function getOptions() {
      return this.options;
    }
    /**
     * 更新选项和比例尺的内部状态
     * @param updateOptions 需要更新的选项
     */

  }, {
    key: "update",
    value: function update() {
      var updateOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.options = deepMix({}, this.options, updateOptions);
      this.rescale(updateOptions);
    }
    /**
     * 根据需要更新 options 和更新后的 options 更新 scale 的内部状态，
     * 在函数内部可以用 this.options 获得更新后的 options
     * @param options 需要更新的 options
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "rescale",
    value: function rescale(options) {}
  }]);

  return Base;
}();